import Vue from "vue";
import base from "../baseMarketing";

export default Object.assign(
    {
        apiUrl: "/channel",

        async sendtype() {
          const url = this.url(`/send-type`);

          return Vue.http.get(url);
      },
    },
    base
);
